// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e7923c8","332":"e469a602","453":"a0942f2d","455":"513e2bfa","977":"ee64e5d8"}[chunkId] + ".chunk.js";
};